module.exports = __webpack_public_path__ + "media/lorkah.5f924b43.mp3";